module.exports = __webpack_public_path__ + "static/media/MaterialIcons-Regular.012cf6a1.woff";